import { IndexType } from 'types/common';

export const DISPLAY_TYPE: IndexType = {
  ALWAYS_ON: '상시',
  DURATION: '기간',
};
